import { PROVIDER_ESCAPIO } from "../api/provider-codes";

export const STATE_LOADING = "loading";
export const STATE_AVAILABLE = "available";
export const STATE_DIRECT_LINK_ONLY = "direct-link-only";
export const STATE_UNAVAILABLE = "unavailable";
export const STATE_ALTERNATIVES = "alternatives";
export const STATE_WITHOUT_DATES = "without-dates";

/**
 * @returns true, if there is an active escapio rate (can be unavailable) for this hotel, false otherwise
 */
export function hasEscapioRate(prices) {
	return prices?.offers?.[0]?.provider == PROVIDER_ESCAPIO;
}

/**
 * @returns true, if there is an active AND available escapio rate for this hotel, false otherwise
 */
export function hasEscapioOffer(prices) {
	return hasEscapioRate(prices) && prices?.offers?.[0]?.total_rate;
}
